import { Box, Typography } from "@mui/material";
import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { EmptyScreenStyles } from "./EmptyScreenStyles";

const EmptyScreen: React.FC = () => {
  return (
    <Box sx={EmptyScreenStyles.screenContainer}>
      <Box sx={EmptyScreenStyles.innerContainer}>
        <CheckCircleOutlineIcon sx={EmptyScreenStyles.icon} />
      </Box>
      <Typography variant="h5" sx={EmptyScreenStyles.title}>
        You're all caught up!
      </Typography>
      <Typography variant="body1" sx={EmptyScreenStyles.subtitle}>
        No tasks assigned right now. Take a moment to relax or create a new
        task.
      </Typography>
    </Box>
  );
};

export default EmptyScreen;
